import type { SVGProps } from 'react';

/** Figma `close-circle.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const CloseCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.2"
      d="M29.3334 15.9993C29.3334 23.3631 23.3639 29.3327 16.0001 29.3327C8.63628 29.3327 2.66675 23.3631 2.66675 15.9993C2.66675 8.63555 8.63628 2.66602 16.0001 2.66602C23.3639 2.66602 29.3334 8.63555 29.3334 15.9993Z"
      fill="currentColor"
    />
    <path
      d="M11.9596 11.9589C12.3502 11.5684 12.9833 11.5684 13.3739 11.9589L16.0001 14.5851L18.6263 11.9589C19.0168 11.5684 19.65 11.5684 20.0405 11.9589C20.431 12.3495 20.431 12.9826 20.0405 13.3732L17.4143 15.9994L20.0405 18.6255C20.431 19.0161 20.431 19.6492 20.0405 20.0398C19.65 20.4303 19.0168 20.4303 18.6263 20.0398L16.0001 17.4136L13.3739 20.0398C12.9834 20.4303 12.3502 20.4303 11.9597 20.0398C11.5691 19.6493 11.5691 19.0161 11.9597 18.6256L14.5859 15.9994L11.9596 13.3731C11.5691 12.9826 11.5691 12.3494 11.9596 11.9589Z"
      fill="currentColor"
    />
  </svg>
);
